// import { BookingType } from "../types/salesOrder.types";

export const ALL_ORDER_TYPES = [
//     BookingType.SINGLE,
//     BookingType.MULTI_ORDER,
//     BookingType.TRUCK_BLEND
];
